export class Link {
   refId: number;
   href: string;
   type: string;
   relationship: string;
}

// ToDo jC: this should replace the second QueryResult
// export class QueryResult<T> {
//    list: Array<T>;
//    links: Array<Link>;
//    totalCount: number;
// }

export class QueryResult {
   list: any[];
   links: any[];
   totalCount: number;
}